<ion-app class="theme-{{ environment.theme }}">
    <ion-router-outlet id="app-content"></ion-router-outlet>
    <ion-toast></ion-toast>
    <ion-alert></ion-alert>
</ion-app>
